import React, { useEffect, useState } from "react";
import ChatArea from "../ChatArea/ChatArea";
import ChatNav from "../ChatNav/ChatNav";
import "./Chat.css";

const ChatBox = ({aid, usr}) => {
  
  return (
    <div className="chat">
      <ChatNav />
      <ChatArea aid={aid} usr={usr} />
    </div>
  );
};

export default ChatBox;
